module.exports = __webpack_public_path__ + "static/media/cloud-meatball.e960e8da.svg";